var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorTile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 269,
    viewBox: "0 0 320 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.472 267.141C314.972 267.141 317.779 264.315 317.779 260.818V89.3081H319.587V260.818C319.587 265.323 315.972 268.96 311.472 268.96H8.11514C3.65345 268.96 0 265.323 0 260.818V248.871H1.8067V260.818C1.8067 264.315 4.61502 267.141 8.11514 267.141H311.472ZM319.587 89.3081H317.779V8.11357C317.779 4.61623 314.972 1.79034 311.472 1.79034H8.11514C4.61502 1.79034 1.8067 4.61623 1.8067 8.11357V50.0537H0V8.11357C0 3.63697 3.65345 0 8.11514 0H311.472C315.972 0 319.587 3.63697 319.587 8.11357V89.3081Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9353 20.0181C18.7218 20.0181 20.9808 17.7592 20.9808 14.9727C20.9808 12.1862 18.7218 9.92725 15.9353 9.92725C13.1487 9.92725 10.8899 12.1862 10.8899 14.9727C10.8899 17.7592 13.1487 20.0181 15.9353 20.0181Z",
    fill: "#9E007E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1794 20.0181C36.966 20.0181 39.2249 17.7592 39.2249 14.9727C39.2249 12.1862 36.966 9.92725 34.1794 9.92725C31.3929 9.92725 29.134 12.1862 29.134 14.9727C29.134 17.7592 31.3929 20.0181 34.1794 20.0181Z",
    fill: "#428DFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4233 20.0181C55.2098 20.0181 57.4688 17.7592 57.4688 14.9727C57.4688 12.1862 55.2098 9.92725 52.4233 9.92725C49.6368 9.92725 47.3779 12.1862 47.3779 14.9727C47.3779 17.7592 49.6368 20.0181 52.4233 20.0181Z",
    fill: "#428DFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M318.699 28.2192H0.901855V30.0256H318.699V28.2192Z",
    fill: "#151515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M206.979 46.3535L77.7886 73.0796L111.377 235.441L240.567 208.715L206.979 46.3535Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.469 176.241C147.083 180.251 128.116 167.787 124.105 148.4C120.095 129.014 132.559 110.047 151.946 106.036C171.332 102.026 190.3 114.49 194.31 133.877C198.321 153.263 185.856 172.23 166.469 176.241Z",
    fill: "#9E007E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.776 130.482L140.141 123.846L182.634 151.792L178.266 158.434L135.776 130.482Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.839 117.701L176.479 122.06L148.567 164.576L141.921 160.213L169.839 117.701Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3828 70.6976L89.7853 72.6428L79.2209 74.8283L112.401 235.215L239.692 208.882L206.512 48.4952L136.493 62.9802L136.091 61.0349L207.069 46.3513C207.593 46.243 208.11 46.5418 208.231 47.1253L241.813 209.458C241.934 210.041 241.578 210.52 241.054 210.629L111.843 237.359C111.319 237.468 110.803 237.169 110.682 236.585L77.0996 74.2529C76.9789 73.6693 77.3346 73.19 77.8584 73.0817L89.3828 70.6976Z",
    fill: "#151515"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80639 249.29L1.8064 68.5068L5.53131e-05 68.5068L4.74108e-05 249.29L1.80639 249.29Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTile);
export default __webpack_public_path__ + "static/media/error-tile.a83cbbbadb8e41e4f7519a7f3eae4d28.svg";
export { ForwardRef as ReactComponent };